import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import React from "react";

export type CtNavbarOptionProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  label: string;
  onClick?: () => void;
  active?: boolean;
};

const bem = new BemHelper("ct-navbar-option");

function CtNavbarOption({ label, active, onClick, href, className, ...rest }: CtNavbarOptionProps) {
  return (
    <li className={classNames(bem.block(), active && bem.modifier("active"), className)}>
      <a href={href || "#"} onClick={onClick} className={classNames(bem.element("link"))} {...rest}>
        {label}
      </a>
    </li>
  );
}

export default CtNavbarOption;
